import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=2bde5685&scoped=true&"
import script from "./ActionCard.vue?vue&type=script&lang=js&"
export * from "./ActionCard.vue?vue&type=script&lang=js&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=2bde5685&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde5685",
  null
  
)

export default component.exports